import React from "react";
import { observer } from "mobx-react";
import { withStyles } from "@material-ui/styles";
import user from "../../stores/userStore";

import {
  Button,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Typography,
  TextField,
  Collapse,
  FormControlLabel,
  Switch,
} from "@material-ui/core";

import Alert from "@material-ui/lab/Alert";
import { withAlert } from "react-alert";

const styles = (theme) => ({
  tableContainer: {
    marginTop: 20,
  },
  table: {
    minWidth: 650,
  },
  button: {
    margin: 0,
  },
  cardDiv: {
    maxWidth: 500,
  },
  cardBtn: {
    width: "100%",
  },
});

const View = observer(
  class UserCreate extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        userid: "",
        userpw: "",
        username: "",
        IsError: false,
        errorMessage: "",
        btnDisable: false,
        checked: false,
      };
    }
    handleChange = (e) => {
      this.setState({
        [e.target.name]: e.target.value,
      });
    };

    handleClick = async () => {
      try {
        this.setState({
          IsError: false,
          btnDisable: true,
        });
        var userid = this.state.userid;
        var userpw = this.state.userpw;
        var username = this.state.username;
        if (userid === "" || userpw === "" || username === "") {
          this.setState({
            IsError: true,
            errorMessage: "입력필드를 확인해주세요.",
            btnDisable: false,
          });
          return;
        }
        await user.makeUser(userid, userpw, username);
        this.setState({
          btnDisable: false,
          userid: "",
          userpw: "",
          username: "",
        });
        this.props.alert.show("생성되었습니다.");
      } catch (error) {
        this.setState({
          IsError: true,
          btnDisable: false,
          errorMessage: error.message,
        });
      }
    };

    handleSwitch = (e) => {
      this.setState({
        [e.target.name]: e.target.checked,
      });
    };

    render() {
      const { classes } = this.props;

      return (
        <div>
          <FormControlLabel
            control={
              <Switch
                checked={this.state.checked}
                onChange={this.handleSwitch}
                name="checked"
                color="primary"
              />
            }
            label="사용자 등록"
          />
          <Collapse in={this.state.checked}>
            <div className={classes.cardDiv}>
              {/* <Typography componet="h2" variant="h5" gutterBottom>
       사용자 등록
     </Typography> */}

              <Card elevation={5}>
                <CardHeader title="사용자 등록" />
                <CardContent>
                  <Typography variant="body1" component="p">
                    아래내용은 전부 입력해주세요. <br />
                  </Typography>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    name="userid"
                    label="ID"
                    type="text"
                    id="userid"
                    autoComplete="current-password"
                    value={this.state.userid}
                    onChange={this.handleChange}
                  />
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    name="userpw"
                    label="Password"
                    type="password"
                    id="userpw"
                    autoComplete="current-password"
                    value={this.state.userpw}
                    onChange={this.handleChange}
                  />
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    name="username"
                    label="이름"
                    type="text"
                    id="username"
                    autoComplete="current-password"
                    value={this.state.username}
                    onChange={this.handleChange}
                  />
                  <Collapse in={this.state.IsError}>
                    <Alert severity="error" className={classes.error}>
                      {this.state.errorMessage}
                    </Alert>
                  </Collapse>
                </CardContent>
                <CardActions>
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    className={classes.cardBtn}
                    onClick={this.handleClick}
                    disabled={this.state.btnDisable}
                  >
                    등록하기
                  </Button>
                </CardActions>
              </Card>
            </div>
          </Collapse>
        </div>
      );
    }
  }
);
const alertView = withAlert()(View);
export default withStyles(styles)(alertView);
